import _ from 'lodash'
import Vue from 'vue'
import { API } from '@/plugins/api'
import { hamiVuex } from '@/store/base'
import { projectStore } from '@/store/project'

export const customerStore = hamiVuex.store({
  $name: 'customer',
  $state: {
    customerMap: {},
  },
  UPSET(customer) {
    this.$patch(state => {
      Vue.set(state.customerMap, customer.id, customer)
    })
  },
  LOAD(customers) {
    let customerMap = {}
    _.forEach(customers, customer => {
      Vue.set(customerMap, customer.id, customer)
    })
    this.$patch(state => {
      state.customerMap = customerMap
    })
  },
  get list() {
    return _.reverse(_.sortBy(_.values(this.customerMap), ['dt_created']))
  },
  get(id) {
    return this.customerMap[id]
  },
  async doQuery(payload) {
    let result = await API.call('merchant/customer.query', payload)
    this.LOAD(result.item_s)
  },
  async doInfo(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/customer.info', payload)
    this.UPSET(result)
  },
  async doQueryLog(payload) {
    let result = await API.call('merchant/customer.query_log', payload)
    return result
  },
  async doPreviewHomeLink(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/customer.preview_home_link', payload)
    return result
  },
})
